export const NATURAL_CHAT_TEMPLATE_MEDIA_NAME = "natural_chat_media";
export const NATURAL_CHAT_TEMPLATE_TEXT_NAME = "natural_chat_text";

export const NEW_NATURAL_CHAT_TEMPLATES = [
	NATURAL_CHAT_TEMPLATE_MEDIA_NAME,
	NATURAL_CHAT_TEMPLATE_TEXT_NAME
];
